<template>
  <slot name="trigger" :open="open"></slot>
  <modal v-model:show="showLocal">
    <slot :close="close"></slot>
  </modal>
</template>
<script setup>
import { ref } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: () => false,
  },
});

const showLocal = ref(props.show);

const open = () => {
  showLocal.value = true;
};

const close = () => {
  showLocal.value = false;
};


</script>
